import { useContext, useEffect, useState, createContext, PropsWithChildren } from 'react';
import IdentityContext from '../../../contexts/IdentityContext';
import useThrowAsyncError from '../../../hooks/useThrowAsyncError';
import { getFavoritesForModule } from '../_api/FavoritesApi';
import ModuleContext from './ModuleContext';

type Favorites = Record<
  string,
  {
    medialinks?: string[];
    userMaterial?: string[];
    whitepages?: string[];
  }
>;

type FavoritesContextValue = {
  favorites: Favorites;
  setFavorites: React.Dispatch<React.SetStateAction<Favorites>>;
};

const FavoritesContext = createContext<FavoritesContextValue>({
  favorites: {},
  setFavorites: () => {},
});

export default FavoritesContext;

export function FavoritesContextProvider({ children }: PropsWithChildren) {
  const { identity } = useContext(IdentityContext);
  const handleError = useThrowAsyncError();

  const { module } = useContext(ModuleContext);
  const [favorites, setFavorites] = useState<Favorites>({});

  useEffect(() => {
    const fetchFavorites = async () => {
      if (!module) return;

      try {
        const data = await getFavoritesForModule(module.id);

        setFavorites(data);
      } catch (e) {
        handleError(e);
      }
    };

    if (identity.isAuthenticated) fetchFavorites();
  }, [handleError, identity.isAuthenticated, module]);

  return <FavoritesContext.Provider value={{ favorites, setFavorites }}>{children}</FavoritesContext.Provider>;
}
